import React from "react"
import { Col, Row } from "react-bootstrap"

import "./article.scss"

const RightImageArticle = ({ children, image, mb, isBlog }) => {
  return (
    <section className={" text-left-image-right image-article"}>
      <div className={isBlog ? " " : "container"}>
        <Row className="align-items-center flex-column-reverse flex-md-row ">
          <Col md="6">{children}</Col>
          <Col md="6" className="mb-2 mb-md-0">
            <img src={image.url} alt={image.alt} className="img-fluid" />
            {image.caption && (
              <div xs="12" className="pt-2 text-muted text-caption text-left">
                <i>{image.caption}</i>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default RightImageArticle
